module.exports = __webpack_public_path__ + "img/street-socket.ba676bfb.svg";